<template>
  <div>
    <template v-if="shipment">
      <v-card class="elevation-12">
        <v-expansion-panels v-model="panels" multiple focusable accordion>
          <v-expansion-panel>
            <v-expansion-panel-header> Новая возвратная счёт-фактура</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="6" lg="3" class="pa-2">
                  <v-text-field v-model="form.number" dense label="Номер счёт-фактуры" :hide-details="true" :error="$v.form.number.$error || isNumberUniqueError" outlined/>
                </v-col>
                <v-col cols="12" sm="6" lg="2" class="pa-2">
                  <DateInput v-model="shipment.date" dense label="Дата счёт-фактуры" :hide-details="true" :disabled="true" outlined :clearable="false" :prepend-icon="false" :append-icon="false"/>
                </v-col>

                <v-col cols="12" lg="6" offset-lg="1" class="pa-2">
                  <v-text-field label="Пункт отгрузки" v-model="shipment.deliveryAddress" dense outlined :hide-details="true" disabled/>
                </v-col>
              </v-row>
              <v-row>
                <template v-if="enableContract">
                  <v-col cols="12" lg="5" class="pa-2">
                    <SelectContract v-model="contract" :dense="true" :buyer-inn="shipment.order.customerInn" :default-value="null" :outlined="true" :disabled="true"/>
                  </v-col>

                </template>
                <template v-else>
                  <v-col cols="12" sm="6" lg="3" class="pa-2">
                    <v-text-field v-model="shipment.contractNumber" dense label="Номер договора" :hide-details="true" outlined :disabled="true"/>
                  </v-col>
                  <v-col cols="12" sm="6" lg="2" class="pa-2">
                    <DateInput v-model="shipment.contractDate" dense label="Дата договора" :hide-details="true" :disabled="true" outlined :clearable="false" :prepend-icon="false" :append-icon="false"/>
                  </v-col>
                </template>

                <v-col cols="12" sm="6" offset-lg="1" lg="3" class="pa-2">
                  <v-text-field v-model="form.correctNumber" dense label="Номер корректировочной счёт-фактуры" :hide-details="true" :error="$v.form.correctNumber.$error" :disabled="true" outlined/>
                </v-col>
                <v-col cols="12" sm="6" lg="2" class="pa-2">
                  <DateInput v-model="form.correctDate" dense label="Дата корректировочной счёт-фактуры" :hide-details="true" :error="$v.form.correctDate.$error" :disabled="true" outlined :clearable="false"
                             :prepend-icon="false" :append-icon="false"/>
                </v-col>
                <v-col cols="12" lg="1" class="pa-2 text-right">
                  <v-dialog v-model="correctInvoiceDialog" fullscreen>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn :color="$v.form.correctNumber.$error || $v.form.correctDate.$error || $v.form.correctInvoiceId.$error ? 'error' : 'primary'" text v-bind="attrs" v-on="on">Выбрать</v-btn>
                    </template>

                    <v-card>
                      <InvoiceDataTable ref="invoiceDataTable"
                                        :invoices="invoices"
                                        :invoices-total="invoicesTotalCount"

                                        :preview-dialog="true"

                                        :start-default-value="defaultValue.start"
                                        :end-default-value="defaultValue.end"
                                        :branch-default-value="defaultValue.branch"
                                        :is-executor-approved-default-value="defaultValue.isExecutorApproved"
                                        :is-customer-approved-default-value="defaultValue.isCustomerApproved"
                                        :is-decline-default-value="defaultValue.isDeclined"
                                        :search-default-value="defaultValue.search"
                                        :page-default-value="defaultValue.page"
                                        :limit-default-value="defaultValue.limit"
                                        :sort-default-value="defaultValue.sort"
                                        :desc-default-value="defaultValue.desc"

                                        @update="onUpdate"
                                        @print="onPrint"
                                        @excel-single="onExcelSingleDownload"
                                        @excel-all="onExcelAllDownload"

                                        :is-executor-approved-disabled="true"
                                        :is-customer-approved-disabled="true"
                                        :is-declined-disabled="true"

                                        :add-headers="[{value: 'selection', text: 'Выбрать', sortable: false}]"
                                        :remove-headers="['actions']"
                      >
                        <template v-slot:title>
                          <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>Выбор основной счёт-фактуры</v-toolbar-title>
                            <v-spacer/>
                            <v-btn @click="correctInvoiceDialog = false" dark text>Закрыть</v-btn>
                          </v-toolbar>
                        </template>

                        <template v-slot:selection="scope">
                          <template
                              v-if="scope.slotScope.item.contractNumber === form.contractNumber && form.contractDate && scope.slotScope.item.contractDate.format('DD.MM.YYYY') == form.contractDate.format('DD.MM.YYYY')">
                            <v-btn text color="primary" @click="correctInvoice = scope.slotScope.item">Выбрать</v-btn>
                          </template>
                          <template v-else>
                            <v-btn text color="error">По договору не подходящий</v-btn>
                          </template>
                        </template>
                      </InvoiceDataTable>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" lg="3" class="pa-2">
                  <v-text-field v-model="shipment.number" dense label="Номер накладной" :hide-details="true" outlined :disabled="true"/>
                </v-col>
                <v-col cols="12" sm="6" lg="2" class="pa-2">
                  <DateInput v-model="shipment.date" dense label="Дата накладной" :hide-details="true" :disabled="true" outlined :clearable="false" :prepend-icon="false" :append-icon="false"/>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Реквизиты сторон</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col lg="6" cols="12">
                  <h3 class="mb-4">Заказчик</h3>
                  <v-text-field label="Наименование" v-model="shipment.consigneeName" dense outlined :hide-details="true" disabled class="my-2"/>
                  <v-text-field label="Инн" v-model="shipment.consigneeInn" dense outlined :hide-details="true" disabled class="my-2"/>

                  <v-text-field label="Адрес" v-model="form.customer.address" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="Расчётный счёт" v-model="form.customer.bankAccount" :error="$v.form.customer.bankAccount.$error" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="МФО" v-model="form.customer.bankMfo" :error="$v.form.customer.bankMfo.$error" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="Название банка" v-model="form.customer.bankName" :error="$v.form.customer.bankName.$error" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="ОКЭД" v-model="form.customer.oked" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="Код НДС регистрации" v-model="form.customer.vatCode" dense outlined :hide-details="true" class="my-2"/>
                </v-col>
                <v-col lg="6" cols="12">
                  <h3 class="mb-4">Поставщик</h3>
                  <v-text-field label="Наименование" v-model="shipment.customerName" dense outlined :hide-details="true" disabled class="my-2"/>
                  <v-text-field label="Инн" v-model="shipment.customerInn" dense outlined :hide-details="true" disabled class="my-2"/>

                  <v-text-field label="Адрес" v-model="form.executor.address" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="Расчётный счёт" v-model="form.executor.bankAccount" :error="$v.form.executor.bankAccount.$error" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="МФО" v-model="form.executor.bankMfo" :error="$v.form.executor.bankMfo.$error" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="Название банка" v-model="form.executor.bankName" :error="$v.form.executor.bankName.$error" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="ОКЭД" v-model="form.executor.oked" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="Код НДС регистрации" v-model="form.executor.vatCode" dense outlined :hide-details="true" class="my-2"/>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Товары и услуги</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-actions>
                  <v-spacer/>
                  <v-dialog v-model="lgotaDialog" max-width="768">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn text v-on="on" v-bind="attrs" color="primary" outlined small>
                        Выбрать льготу для всех позиций
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-title class="headline grey lighten-2"> Выбор льготы</v-card-title>
                      <v-card-text>
                        <SelectInvoiceItemLgota v-model="lgota"/>
                      </v-card-text>
                      <v-divider/>
                      <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" text @click="lgotaDialog = false"> Закрыть</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <SelectInvoiceItemCatalog :product-catalogs="productCatalogs" :disable-package="true" :selected-catalog="catalog" title="Выбрать МХИК для всех позиций"
                                     @selected="(catalog, catalogPackage, lgota) => onMxikSelected(catalog, catalogPackage, lgota)"/>
                </v-card-actions>
              </v-card>

              <v-divider/>

              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-center py-0 pa-1" style="width: 40px;">№</th>
                    <th class="text-center py-0 pa-1" style="width: 70px">ИКПУ-код</th>
                    <th class="text-left py-0 pa-1">Товар</th>
                    <th class="text-center py-0 pa-1" style="width: 115px;">Льгота</th>
                    <th class="text-center py-0 pa-1" style="width: 115px;">ИД позиции поставки</th>
                    <th class="text-center py-0 pa-1" style="width: 100px;">Штрих-код</th>
                    <th class="text-center py-0 pa-1" style="width: 40px;">Ед.изм</th>
                    <th class="text-right py-0 pa-1" style="width: 60px;">Количество</th>
                    <th class="text-right py-0 pa-1" style="width: 120px;">Цена за единицу</th>
                    <th class="text-right py-0 pa-1" style="width: 125px;">Стоимость</th>
                    <th class="text-center py-0 pa-1" style="width: 50px;">Ставка ндс</th>
                    <th class="text-right py-0 pa-1" style="width: 125px;">Сумма ндс</th>
                    <th class="text-right py-0 pa-1" style="width: 125px;">Стоимость с учётом НДС</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in form.items" :key="item.id">
                    <td class="text-center py-0 pa-1">{{ index + 1 }}</td>
                    <td class="text-center py-0 pa-1">
                      <SelectMxikProduct :product-catalogs="productCatalogs" :disable-package="true" :error="$v.form.items.$each[index].catalog.$error" :selected-catalog="item.catalog"
                                         :default-catalog="item.defaultCatalogCode" :default-package="item.defaultCatalogPackageCode"
                                         @selected="(catalog, catalogPackage) => onItemMxikSelected(item, catalog, catalogPackage)"/>
                    </td>
                    <td class="text-left py-0 pa-1">{{ item.product }}</td>
                    <td class="text-left py-0 pa-1">
                      <v-dialog v-model="item.lgotaDialog" max-width="768">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn text :color="$v.form.items.$each[index].lgota.$error ? 'error' : 'primary'" v-on="on" v-bind="attrs" small outlined>
                            {{ item.lgota ? item.lgota : 'Выбрать' }}
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-title class="headline grey lighten-2"> Выбор льготы</v-card-title>
                          <v-card-text>
                            <CatalogCodeLgota v-model="item.lgota" :catalog-code="item.catalog" />
                          </v-card-text>
                          <v-divider/>
                          <v-card-actions>
                            <v-spacer/>
                            <v-btn color="primary" text @click="item.lgotaDialog = false"> Закрыть</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </td>
                    <td class="text-center py-0 pa-1">
                      <template v-if="item.orderItem.customerShipmentItemId">
                        {{ item.orderItem.customerShipmentItemId }}
                      </template>
                      <template v-else>
                        Нет
                      </template>
                    </td>
                    <td class="text-center py-0 pa-1">
                      <template v-if="item.customerCode">
                        {{ item.customerCode }}
                      </template>
                      <template v-else>
                        Нет
                      </template>
                    </td>
                    <td class="text-center py-0 pa-1">
                      <template v-if="item.catalogPackage">
                        {{ item.catalogPackage.nameRu }}
                      </template>
                      <template v-else>
                        {{ item.measurement }}
                      </template>
                    </td>
                    <td class="text-right py-0 pa-1">
                      {{ item.quantity | decimalNoTrim }}
                    </td>
                    <td class="text-right py-0 pa-1">{{ item.price | decimalNoTrim }}</td>
                    <td class="text-right py-0 pa-1">{{ item.total | decimalMinorCeilTwoDigit }}</td>
                    <td class="text-center py-0 pa-1">{{ item.ndsRate | decimalNoTrim }}</td>
                    <td class="text-right py-0 pa-1">
                      {{ item.ndsValue | decimalMinorCeilTwoDigit }}
                    </td>
                    <td class="text-right py-0 pa-1">
                      {{ item.totalWithNds | decimalMinorCeilTwoDigit }}
                    </td>
                  </tr>
                  <tr class="blue-grey lighten-4">
                    <td></td>
                    <td class="text-left px-1"><b>Итого</b></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                    <td class="text-right py-0 pa-1"><b>{{ totals.total |  decimalMinorCeilTwoDigit }}</b></td>
                    <td class="text-right"></td>
                    <td class="text-right py-0 pa-1"><b>{{ totals.ndsValue |  decimalMinorCeilTwoDigit }}</b></td>
                    <td class="text-right py-0 pa-1"><b>{{ totals.totalWithNds | decimalMinorCeilTwoDigit }}</b></td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Подписи сторон</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" lg="6" class="pa-2">
                  <v-text-field v-model="form.executorDirector" dense label="Руководитель предприятия" :hide-details="true" :error="$v.form.executorDirector.$error" outlined/>
                </v-col>
                <v-col cols="12" lg="6" class="pa-2">
                  <v-text-field v-model="form.customerProxyName" dense label="ФИО получателя" :hide-details="true" :error="$v.form.customerProxyName.$error" outlined/>
                </v-col>

              </v-row>
              <v-row>
                <v-col cols="12" lg="6" class="pa-2">
                  <v-text-field v-model="form.executorAccountant" dense label="Главный бухгалтер" :hide-details="true" :error="$v.form.executorAccountant.$error" outlined/>
                </v-col>
                <v-col cols="12" lg="6" class="pa-2">
                  <v-text-field v-model="form.customerProxyNumber" dense label="Номер доверенности" :hide-details="true" :error="$v.form.customerProxyNumber.$error" outlined/>
                </v-col>

              </v-row>
              <v-row>
                <v-col cols="12" lg="6" class="pa-2">
                  <v-text-field v-model="form.executorReleaser" dense label="Товар отпустил" :hide-details="true" :error="$v.form.executorReleaser.$error" outlined/>
                </v-col>
                <v-col cols="12" lg="6" class="pa-2">
                  <DateInput v-model="form.customerProxyDate" dense label="Дата доверенности" :hide-details="true" outlined :append-icon="true" :prepend-icon="false"/>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="onSaveButtonClicked"> Создать</v-btn>
        </v-card-actions>
      </v-card>

      <v-dialog v-model="saveFailedDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 error--text"> Ошибка при обработке запроса на сервере</v-card-title>
          <v-card-text> {{ saveFailedDialogText }}</v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" text @click="saveFailedDialog = false">Закрыть</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-else>
      <h3>Идет загрузка...</h3>
    </template>
  </div>
</template>

<script>

import {validationMixin} from "vuelidate";
import SelectInvoiceItemLgota from "@/components/Select/SelectInvoiceItemLgota";
import SelectInvoiceItemCatalog from "@/components/Select/SelectInvoiceItemCatalog";
import SelectMxikProduct from "@/components/Select/SelectMxikProduct";
import DateInput from "@/components/Input/DateInput";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
import * as LayoutActions from "@/store/modules/layout/actions";
import ReturnShipmentService from "@/services/return.shipment.service";
import Moment from "moment";
import _ from "underscore";
import mappers from "@/helpers/mappers";
import ReturnInvoiceService from "@/services/return.invoice.service";
import CompanyService from "@/services/company.service";
import BankService from "@/services/bank.service";
import {MOMENT_API_DATE_FORMAT} from "@/settings";
import InvoiceDataTable from "@/components/DataTables/InvoiceDataTable";
import InvoiceBoxMixin from "@/views/main/invoice/box/InvoiceBoxMixin";
import {DefineInOrder} from "@/enum/OrderContractDefineMethodStrategyType";
import SelectContract from "@/components/Select/SelectContract";
const StorageMxikCatalogPackageKey = "mxik-catalog-package"
import CatalogCodeLgota from "@/components/Select/SelectInvoiceCatalogLgota"

export default {
  name: "AddReturnInvoiceView",
  mixins: [validationMixin, InvoiceBoxMixin],
  components: {SelectContract, InvoiceDataTable, SelectInvoiceItemLgota, SelectMxikProduct, DateInput, CatalogCodeLgota, SelectInvoiceItemCatalog},
  validations: {
    form: {
      number: {
        required,
        maxLength: maxLength(100),
      },
      correctNumber: {
        required,
        maxLength: maxLength(100)
      },
      correctDate: {
        required
      },
      correctInvoiceId: {
        required
      },
      contractNumber: {
        required,
        maxLength: maxLength(100)
      },
      contractDate: {
        required
      },
      executorDirector: {
        required,
        maxLength: maxLength(100)
      },
      executorAccountant: {
        required,
        maxLength: maxLength(100)
      },
      executorReleaser: {
        required,
        maxLength: maxLength(100)
      },
      customerProxyNumber: {
        maxLength: maxLength(100)
      },
      customerProxyName: {
        maxLength: maxLength(100)
      },
      executor: {
        address: {
          maxLength: maxLength(500)
        },
        bankAccount: {
          required,
          maxLength: maxLength(20),
          minLength: minLength(20),
          format: numeric
        },
        bankName: {
          required,
          maxLength: maxLength(500)
        },
        bankMfo: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(5),
          format: numeric
        },
        oked: {
          minLength: minLength(5),
          maxLength: maxLength(5),
          format: numeric
        },
        vatCode: {
          format: numeric
        }
      },
      customer: {
        address: {
          maxLength: maxLength(500)
        },
        bankAccount: {
          required,
          maxLength: maxLength(20),
          minLength: minLength(20),
          format: numeric
        },
        bankName: {
          required,
          maxLength: maxLength(500)
        },
        bankMfo: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(5),
          format: numeric
        },
        oked: {
          minLength: minLength(5),
          maxLength: maxLength(5),
          format: numeric
        },
        vatCode: {
          format: numeric
        }
      },
      items: {
        required,
        $each: {
          lgota: {
            required(value, model) {
              if (this.form.executor.vatCode && model.ndsRate === 0)
                return !!value
              return true
            }
          },
          catalog: {
            required
          },
          barcode: {
            maxLength: maxLength(50)
          },
          measurement: {
            required
          }
        }
      }
    }
  },
  data() {
    return {
      shipment: null,
      enableContract: false,
      previousInvoice: null,
      correctInvoiceDialog: false,
      correctInvoice: null,
      productCatalogs: [],
      loading: false,
      panels: [0, 1, 2, 3],
      totals: {
        total: 0,
        ndsValue: 0,
        totalWithNds: 0
      },
      catalog: null,
      catalogPackage: null,
      lgota: null,
      lgotaDialog: false,

      saveFailedDialogText: '',
      saveFailedDialog: false,

      isNumberUniqueError: false,
      form: {
        number: '',
        executorDirector: '',
        executorAccountant: '',
        executorReleaser: '',

        contractNumber: '',
        contractDate: null,

        correctNumber: '',
        correctDate: null,
        correctInvoiceId: null,

        customerProxyName: '',
        customerProxyNumber: '',
        customerProxyDate: null,

        executor: {
          address: '',
          bankAccount: '',
          bankName: '',
          bankMfo: '',
          oked: '',
          vatCode: ''
        },
        customer: {
          address: '',
          bankAccount: '',
          bankName: '',
          bankMfo: '',
          oked: '',
          vatCode: ''
        },

        items: []
      },
      contract: null
    }
  },
  methods: {
    loadShipment() {
      this.$store.dispatch(LayoutActions.LAYOUT_LOADING_START)
      this.loading = true
      ReturnShipmentService.getInfo(this.$route.params.id)
          .then(response => {
            this.shipment = mappers.mapReturnShipmentInfo(response.data)

            this.onShipmentLoaded()
          })
          .catch(e => {
            window.console.log(e)
            this.$router.go(-1)
          })
          .finally(() => {
            this.loading = false
            this.$store.dispatch(LayoutActions.LAYOUT_LOADING_STOP)
          })
    },
    loadPreviousInvoice() {
      ReturnInvoiceService.getExecutorLastInfo()
          .then(response => {
            this.previousInvoice = {
              executorDirector: response.data.ExecutorDirector,
              executorAccountant: response.data.ExecutorAcccountant,
              executorReleaser: response.data.ExecutorReleaser,
              customerProxyName: response.data.CustomerProxyName,
              customerProxyNumber: response.data.CustomerProxyNumber,
              customerProxyDate: response.data.CustomerProxyDate ? Moment(response.data.CustomerProxyDate) : null,
            }

            this.onPreviousInvoiceLoaded()
          })
    },
    loadCompanyDetails(inn, member) {
      CompanyService.getSoliqDetails(inn)
          .then(response => {
            member.address = response.data.Address || ''
            member.bankAccount = response.data.Account || ''
            member.bankMfo = response.data.Mfo || ''
            member.address = response.data.Address || ''
            member.oked = response.data.Oked || ''

            if (member.bankMfo) {
              BankService.get(member.bankMfo)
                  .then(response => {
                    member.bankName = response.data.Name || ''
                  })
            }
          })
      CompanyService.getVatCode(inn)
          .then(response => {
            if (response.data)
              member.vatCode = response.data || ''
          })
    },
    loadProductCatalogs() {
      CompanyService.getCompanyCatalogCodesInfo()
          .then(response => {
            this.productCatalogs = response.data
          })
    },

    onShipmentLoaded() {
      let mxikCatalogPackages = {}

      try {
        const storageValue = localStorage.getItem(StorageMxikCatalogPackageKey)
        if (storageValue)
          mxikCatalogPackages = JSON.parse(storageValue)

        _.each(this.form.items, item => {
          mxikCatalogPackages[item.product] = {
            catalogCode: item.catalog.classCode,
            catalogPackageCode: item.catalogPackage ? item.catalogPackage.code : null
          }
        })
      } catch (e) {
        window.console.log(e)
      }

      this.enableContract = this.shipment.order.contractDefineMethodStrategy !== DefineInOrder
      if (this.enableContract) {
        this.form.contractNumber = ''
        this.form.contractDate = null
      } else {
        this.form.contractNumber = this.shipment.order.contractNumber
        this.form.contractDate = this.shipment.order.contractDate
      }

      this.form.number = this.shipment.number
      this.form.items = this.shipment.items.filter(item => {
        return item.quantity !== 0
      }).map(item => {
        const mxikCatalogPackage = mxikCatalogPackages[item.product] || null

        return {
          id: item.id,
          product: item.product,
          customerCode: item.customerCode,
          catalogCode: item.catalogCode,
          catalogName: item.catalogName,
          measurement: item.measurement,
          quantity: item.quantity,
          price: item.price,
          total: item.total,
          ndsRate: item.ndsRate,
          ndsValue: item.ndsValue,
          totalWithNds: item.totalWithNds,
          orderItem: item.orderItem,
          measurement_code: null,
          catalog: null,
          catalogPackage: null,
          lgota: null,
          lgotaDialog: false,
          defaultCatalogCode: mxikCatalogPackage ? mxikCatalogPackage.catalogCode : null,
          defaultCatalogPackageCode: mxikCatalogPackage ? mxikCatalogPackage.catalogPackageCode : null
        }
      })

      this.totals.total = _.reduce(this.shipment.items, (memo, item) => {
        return memo + item.total
      }, 0)
      this.totals.ndsValue = _.reduce(this.shipment.items, (memo, item) => {
        return memo + item.ndsValue
      }, 0)
      this.totals.totalWithNds = _.reduce(this.shipment.items, (memo, item) => {
        return memo + item.totalWithNds
      }, 0)

      this.loadCompanyDetails(this.shipment.consigneeInn, this.form.customer)
      this.loadCompanyDetails(this.shipment.customerInn, this.form.executor)

      this.loadProductCatalogs()
    },
    onCorrectInvoiceSelected() {
      if (this.correctInvoice) {
        this.form.correctInvoiceId = this.correctInvoice.id
        this.form.correctNumber = this.correctInvoice.number
        this.form.correctDate = this.correctInvoice.date

        this.correctInvoiceDialog = false
      }
    },
    onPreviousInvoiceLoaded() {
      this.form.executorDirector = this.previousInvoice.executorDirector || ''
      this.form.executorAccountant = this.previousInvoice.executorAccountant || ''
      this.form.executorReleaser = this.previousInvoice.executorReleaser || ''
      this.form.customerProxyName = this.previousInvoice.customerProxyName || ''
      this.form.customerProxyNumber = this.previousInvoice.customerProxyNumber || ''
      this.form.customerProxyDate = this.previousInvoice.customerProxyDate
    },
    onItemMxikSelected(item, catalog, catalogPackage) {
      item.catalog = catalog
      item.catalogPackage = catalogPackage
    },
    onMxikSelected(catalog, catalogPackage, lgota) {
      _.each(this.form.items, item => {
        item.catalog = catalog || null
        item.catalogPackage = catalogPackage || null
        item.lgota = lgota || null
      })
    },
    onSaveButtonClicked() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const data = {
          CorrectNumber: this.form.correctNumber,
          CorrectDate: this.form.correctDate.format(MOMENT_API_DATE_FORMAT),
          CorrectInvoiceId: this.form.correctInvoiceId,
          ShipmentId: this.shipment.id,
          Number: this.form.number,
          Date: this.shipment.date.format(MOMENT_API_DATE_FORMAT),
          ContractNumber: this.form.contractNumber,
          ContractDate: this.form.contractDate.format(MOMENT_API_DATE_FORMAT),
          CustomerDetail: {
            Inn: this.shipment.consigneeInn,
            Name: this.shipment.consigneeName,
            Address: this.form.customer.address,
            BankAccountNumber: this.form.customer.bankAccount,
            BankName: this.form.customer.bankName,
            BankMfo: this.form.customer.bankMfo,
            Oked: this.form.customer.oked,
            NdsRegistrationCode: this.form.customer.vatCode ? this.form.customer.vatCode : null
          },
          ExecutorDetail: {
            Inn: this.shipment.customerInn,
            Name: this.shipment.customerName,
            Address: this.form.executor.address,
            BankAccountNumber: this.form.executor.bankAccount,
            BankName: this.form.executor.bankName,
            BankMfo: this.form.executor.bankMfo,
            Oked: this.form.executor.oked,
            NdsRegistrationCode: this.form.executor.vatCode ? this.form.executor.vatCode : null
          },
          ExecutorDirector: this.form.executorDirector,
          ExecutorAcccountant: this.form.executorAccountant,
          ExecutorReleaser: this.form.executorReleaser,
          CustomerProxyNumber: this.form.customerProxyNumber,
          CustomerProxyDate: this.form.customerProxyDate ? this.form.customerProxyDate.format(MOMENT_API_DATE_FORMAT) : null,
          CustomerProxyName: this.form.customerProxyName,
          Items: _.map(this.form.items, i => {
            return {
              ReturnShipmentItemId: i.id,
              Measurement: i.catalogPackage ? i.catalogPackage.nameRu : i.measurement,
              MeasurementCode: i.catalogPackage ? i.catalogPackage.code : null,
              CatalogCode: i.catalog.classCode,
              CatalogName: i.catalog.name,
              LgotaId: i.lgota
            }
          })
        }

        this.$store.dispatch(LayoutActions.LAYOUT_LOADING_START)
        this.loading = true
        this.isNumberUniqueError = false
        ReturnInvoiceService.register(data)
            .then(response => {
              try {
                let mxikCatalogPackages = {}
                const storageValue = localStorage.getItem(StorageMxikCatalogPackageKey)
                if (storageValue)
                  mxikCatalogPackages = JSON.parse(storageValue)

                _.each(this.form.items, item => {
                  mxikCatalogPackages[item.product] = {
                    catalogCode: item.catalog.classCode,
                    catalogPackageCode: item.catalogPackage ? item.catalogPackage.code : null
                  }
                })

                localStorage.setItem(StorageMxikCatalogPackageKey, JSON.stringify(mxikCatalogPackages))
              } catch (e) {
                window.console.log(e)
              }

              this.$router.push({name: 'return-invoice-page', params: {id: response.data.Id}});
            })
            .catch(exception => {
              window.console.log(exception)
              if (exception.response && exception.response.data && exception.response.data.Message && exception.response.data.Message.Message) {
                this.saveFailedDialogText = exception.response.data.Message.Message
                this.saveFailedDialog = true

                this.isNumberUniqueError = exception.response.data.Message.Code === 102
              }
            })
            .finally(() => {
              this.$store.dispatch(LayoutActions.LAYOUT_LOADING_STOP)
              this.loading = false
            })
      }
    },
    onEventContractChanged() {
      if (this.contract) {
        this.form.contractNumber = this.contract.number
        this.form.contractDate = this.contract.date
      } else {
        this.form.contractNumber = ''
        this.form.contractDate = null
      }
    },
  },
  created() {
    this.loadShipment()
    this.loadPreviousInvoice()

    this.defaultValue.isExecutorApproved = true
    this.defaultValue.isCustomerApproved = true
  },
  watch: {
    correctInvoice() {
      this.onCorrectInvoiceSelected()
    },
    lgota() {
      if (this.lgota)
        _.each(this.form.items, item => {
          item.lgota = this.lgota
        })
    },
    contract() {
      this.onEventContractChanged()
    }
  }
}
</script>